<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {},
  data() {
    return {}
  },
  created() {
    // console.log(navigator)
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.$store.state.screen_height = window.innerHeight
      this.$store.state.screen_width = window.innerWidth
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue